var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 3.93V29a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V1.5a.5.5 0 0 1 .5-.5h10.111a.5.5 0 0 1 .5.5v1.43a.5.5 0 0 0 .5.5H40.5a.5.5 0 0 1 .5.5Z",
    fill: "#F6C358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.6 1.5a.9.9 0 0 1 .9-.9h10.11a.9.9 0 0 1 .9.9v1.43a.1.1 0 0 0 .1.1H40.5a.9.9 0 0 1 .9.9V29a2.4 2.4 0 0 1-2.4 2.4H3A2.4 2.4 0 0 1 .6 29V1.5Zm.9-.1a.1.1 0 0 0-.1.1V29A1.6 1.6 0 0 0 3 30.6h36a1.6 1.6 0 0 0 1.6-1.6V3.93a.1.1 0 0 0-.1-.1H12.61a.9.9 0 0 1-.9-.9V1.5a.1.1 0 0 0-.1-.1H1.5Z",
    fill: "#F6C358"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.353h13.185a2 2 0 0 0 1.252-.44l5.844-4.693a1 1 0 0 1 .626-.22H41v24a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V10.353Z",
    fill: "#FCD462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 29V6H21.907l-5.843 4.692a3 3 0 0 1-1.879.66H2V29a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1ZM1 10.353V29a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V5H21.907a1 1 0 0 0-.626.22l-5.843 4.692a2 2 0 0 1-1.253.44H1Z",
    fill: "#FCD462"
  })));
};
export default SvgFolder;